<template>
  <div class="d-flex flex-column">
    <div class="d-flex justify-content-center align-items-center mb-2" v-if="false">
        <button class="btn btn-info btn-sm mr-2" @click="page > 1 ? page-- : 1">Back</button>
        <div class="display bg-light">{{page}} / {{ numPages ? numPages : '∞' }}</div>
        <button class="btn btn-info btn-sm ml-2" @click="page < numPages ? page++ : 1">Forward</button>
    </div>
    <pdfvuer
      class="d-flex justify-content-center pdfPage"
      :src="pdfdata"
      v-for="i in numPages"
      :key="i"
      :id="i"
      :page="i"
      :scale.sync="scale"
      :annotation="true"
      :resize="true"
      :text="false">
      <template slot="loading">
        Loading content here...
      </template>
    </pdfvuer>
  </div>
</template>

<script>
import pdfvuer from 'pdfvuer'
import 'pdfjs-dist/build/pdf.worker.entry'

export default {
  name: 'PDFViewer',
  components: { pdfvuer },
  data () {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: 'page-width'
    }
  },
  props: {
    data: {
      type: [String, Object],
      required: true
    }
  },
  mounted () {
    this.getPdf()
  },
  methods: {
    getPdf () {
      if (this.data) {
        this.pdfdata = pdfvuer.createLoadingTask(this.data)
        this.pdfdata.then(pdf => {
          this.numPages = pdf.numPages
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.display {
  font-size: 1.5rem;
  font-weight: 400;
  color: #333;
  padding: 2px 30px;
}
.pdfPage {
  width: 100%;
  margin: 5px auto;
  padding: 10px;
  background: #f1f1f1;
  border-radius: 3px;
}
</style>
